import { render, staticRenderFns } from "./common-wrong.vue?vue&type=template&id=1eb4edbe&scoped=true"
import script from "./common-wrong.vue?vue&type=script&lang=js"
export * from "./common-wrong.vue?vue&type=script&lang=js"
import style0 from "./common-wrong.vue?vue&type=style&index=0&id=1eb4edbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb4edbe",
  null
  
)

export default component.exports